import SocialMediaLinks from './SocialMediaLinks';

export default SocialMediaLinks;
